import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-download-control-test',
  templateUrl: './download-control-test.component.html',
  styleUrls: ['./download-control-test.component.css']
})
export class DownloadControlTestComponent implements OnInit {

  filePath;
  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/download-control-test/download-control-test.component.ts